<template>
    <van-popup v-if="recordAddEditPopupShow " :value="recordAddEditPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="project_record_wrap" ref="recordDialog" v-loading="loading">
            <div class="project_record_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
            </div>

            <div class="project_record_bottom">
                <van-form colon ref="formData" scroll-to-error>
                    <ul>
                        <li>
                            <van-field :rules="formRules.created_at" input-align="right" @click="calendarShow = true" label="记录日期"  placeholder="请选择" required is-link v-model="formData.created_at"></van-field>
                        </li>
                        <li>
                            <div   class="vertical_input_wrap">
                                <van-field v-model="formData.content"  label="记录内容" placeholder="请输入"  required    :rules="formRules.content"   type="textarea">
                                    <template #input>
                                        <div
                                                id="commentTextarea"
                                                ref="commentTextarea"
                                                class="commentTextarea"
                                                contenteditable="true"
                                                @keydown="handleKeyDown"
                                                @keyup="handleKeyUp"
                                        ></div>
                                    </template>
                                </van-field>
                            </div>
                        </li>
                    </ul>
                </van-form>
            </div>

            <div class="project_record_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
            </div>


            <van-popup v-model="calendarShow" :close-on-click-overlay="true"  :style="{ height: '70vh',background:'#F7F8FA' }"  position="bottom"  round  @click-overlay="handleClickCalendarClose">
                <van-calendar  :allow-same-day="true" :max-date="dateCalendarMax" :min-date="dateCalendarMin" :default-date="defaultDate"	 :poppable="false"
                               :show-confirm="true" :show-title="false"  color="#1990FF" type="single" @confirm="handleClickCalendarConfirm"></van-calendar>

            </van-popup>

            <AtDialog
                    v-if="showDialog"
                    :position="position"
                    :queryString="queryString"
                    :showDialog.sync="showDialog"
                    @onHide="handleHide"
                    @onPickUser="handlePickUser"
                    @onShow="handleShow"
            />


        </div>
    </van-popup>
</template>

<script>
import { ProjectLogAdd,ProjectLogDetail,ProjectLogEdit } from "@/api/index.js"
import {Dialog} from "vant";
import {formatDate,getNowDate} from "@/utils";
import AtDialog from "@/components/pComponents/AtDialog";
export default {
    name: "record_tpl",
    components: {AtDialog},
    props: {
        recordAddEditPopupShow: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: [String,Number],
            default: '0'
        },
        recordId: {
            type: [String,Number],
            default: 0
        },

    },
    data() {
        return {
            defaultImg: require('@/assets/images/default.jpg'),
            loading:false,
            btnDisabled:false,
            formData: {
                created_at:getNowDate(),
                content: "",
            },
            formRules: {
                created_at: [{required: true, message: "请选择记录日期", trigger: 'onChange'}],
                content: [{required: true, message: "请输入记录内容", trigger: 'onChange'}],
            },
            calendarShow:false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
            defaultDate:new Date(),

            placeholderText:'请输入记录内容',
            userList: [],
            showDialog: false, // 是否显示弹窗
            node: "", // 获取到节点
            endIndex: "", // 光标最后停留位置
            queryString: "", // 搜索值
            position: {
                x: 530,
                y: 300,
            }, // 弹窗显示位置
        };
    },

    created() {
        this.placeholder()
        if(this.recordId){
            this.getProjectLogDetail()
        }
    },
    methods: {
        getProjectLogDetail(){
            this.loading = true
            ProjectLogDetail({id:this.recordId}).then(res => {
                if (res.code === 200) {
                    this.formData.created_at = res.data.created_at.substring(0, 10)
                    this.formData.content = res.data.content.text
                    this.$refs.commentTextarea.innerHTML = res.data.content.text
                    this.defaultDate = new Date(this.formData.created_at)
                    this.placeholder()
                }
                this.loading = false
            })
        },
        handleClickCalendarClose(){

        },
        handleClickCalendarConfirm(date){
            this.formData.created_at = formatDate(date, 'date')
            this.calendarShow = false
        },
        handleClickClose(){
            this.$emit("update:recordAddEditPopupShow", false)
        },

        handleClickConfirm(){
            this.$refs.formData.validate().then(() => {
                let postData = this.getCommentContent()
                postData.created_at =  this.formData.created_at
                postData.project_manage_id = this.projectId
                this.btnDisabled = true
                if(this.recordId){
                    postData.id = this.recordId
                    ProjectLogEdit(postData).then(res => {
                        if (res.code === 200) {
                            this.$toast({
                                message:'编辑成功',
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.$emit("update:recordAddEditPopupShow", false)
                                    this.$emit('success')

                                },
                            });
                        }else{
                            this.btnDisabled = false
                        }
                    })
                }else {
                    ProjectLogAdd(postData).then(res => {
                        if (res.code === 200) {
                            this.$toast({
                                message:'新增成功',
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.$emit("update:recordAddEditPopupShow", false)
                                    this.$emit('success')
                                },
                            });
                        }else{
                            this.btnDisabled = false
                        }
                    })
                }

            })
        },


        placeholder() {
            this.$nextTick(() => {
                var div = document.getElementById("commentTextarea");
                if (div.textContent.trim() === "") {
                    div.setAttribute("data-placeholder", this.placeholderText);
                } else {
                    div.setAttribute("data-placeholder", "");
                }
            });
        },
        getCommentContent() {
            let commentText = this.$refs.commentTextarea.innerHTML;
            const spanArr = this.$refs.commentTextarea.querySelectorAll(".at-button");
            const atPeople = [];
            const at_uid = [];
            if (spanArr.length > 0) {
                spanArr.forEach((item) => {
                    atPeople.push(JSON.parse(item.dataset.user));
                });
                atPeople.forEach((item, key) => {
                    at_uid.push(item.uid);
                });
            }
            return {
                content: commentText,
                at_uid: at_uid.join(","),
                at_people: atPeople,
            };
        },
        // 获取光标位置
        getCursorIndex() {
            const selection = window.getSelection();
            return selection.focusOffset; // 选择开始处 focusNode 的偏移量
        },

        // 获取节点
        getRangeNode() {
            const selection = window.getSelection();
            return selection.focusNode; // 选择的结束节点
        },

        // 弹窗出现的位置
        getRangeRect() {
            const selection = window.getSelection();
            const range = selection.getRangeAt(0); // 是用于管理选择范围的通用对象
            const rect = range.getClientRects()[0]; // 择一些文本并将获得所选文本的范围
            const LINE_HEIGHT = 30;
            return {
                x: rect.x,
                y: rect.y + LINE_HEIGHT,
            };
        },

        // 是否展示 @
        showAt() {
            const node = this.getRangeNode();
            if (!node || node.nodeType !== Node.TEXT_NODE) return false;
            const content = node.textContent || "";
            const regx = /@([^@\s]*)$/;
            const match = regx.exec(content.slice(0, this.getCursorIndex()));
            return match && match.length === 2;
        },

        // 获取 @ 用户
        getAtUser() {
            const content = this.getRangeNode().textContent || "";
            const regx = /@([^@\s]*)$/;
            const match = regx.exec(content.slice(0, this.getCursorIndex()));
            if (match && match.length === 2) {
                return match[1];
            }
            return undefined;
        },

        // 创建标签
        createAtButton(user) {
            const btn = document.createElement("span");
            btn.style.display = "inline-block";
            btn.dataset.user = JSON.stringify(user);
            btn.className = "at-button";
            btn.contentEditable = "false";
            btn.textContent = `@${user.name}`;
            btn.style.color = "#409eff";
            return btn;
        },

        replaceString(raw, replacer) {
            return raw.replace(/@([^@\s]*)$/, replacer);
        },

        // 插入@标签
        replaceAtUser(user) {
            const node = this.node;
            if (node && user) {
                const content = node.textContent || "";
                const endIndex = this.endIndex;
                const preSlice = this.replaceString(content.slice(0, endIndex), "");
                const restSlice = content.slice(endIndex);
                const parentNode = node.parentNode;
                const nextNode = node.nextSibling;
                const previousTextNode = new Text(preSlice);
                const nextTextNode = new Text("\u200b" + restSlice); // 添加 0 宽字符
                const atButton = this.createAtButton(user);
                parentNode.removeChild(node);
                // 插在文本框中
                if (nextNode) {
                    parentNode.insertBefore(previousTextNode, nextNode);
                    parentNode.insertBefore(atButton, nextNode);
                    parentNode.insertBefore(nextTextNode, nextNode);
                } else {
                    parentNode.appendChild(previousTextNode);
                    parentNode.appendChild(atButton);
                    parentNode.appendChild(nextTextNode);
                }
                // 重置光标的位置
                const range = new Range();
                const selection = window.getSelection();
                range.setStart(nextTextNode, 0);
                range.setEnd(nextTextNode, 0);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },

        // 键盘抬起事件
        handleKeyUp() {
            if (this.showAt()) {
                const node = this.getRangeNode();
                const endIndex = this.getCursorIndex();
                this.node = node;
                this.endIndex = endIndex;
                this.position = this.getRangeRect();
                this.queryString = this.getAtUser() || "";
                this.showDialog = true;
            } else {
                this.showDialog = false;
            }
            this.placeholder()
            var div = document.getElementById("commentTextarea");
            this.formData.content = div.textContent
            this.$refs.formData.validateField('content');
        },

        // 键盘按下事件
        handleKeyDown(e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                const selection = window.getSelection();
                const range = selection.getRangeAt(0);
                const br = document.createElement("br");
                range.insertNode(br);
                range.setStartAfter(br);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);
            }
            if (this.showDialog) {
                if (e.code === "ArrowUp" || e.code === "ArrowDown" || e.code === "Enter") {
                    e.preventDefault();
                }
            }

        },

        // 插入标签后隐藏选择框
        handlePickUser(user) {
            this.replaceAtUser(user);
            this.user = user;
            this.showDialog = false;
        },
        // 隐藏选择框
        handleHide() {
            this.showDialog = false;
        },

        // 显示选择框
        handleShow() {
            this.showDialog = true;
        },

    },
}
</script>

<style  lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
.commentTextarea {
    width: 100%;
    height: 204px;
    display: block;
    line-height: 1.5;
    box-sizing: border-box;
    color: #606266;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    overflow-y: scroll;
    position: relative;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    &::before {
        content: attr(data-placeholder);
        position: absolute;
        top: 2px;
        left: 0px;
        color: rgb(193, 192, 192);
        pointer-events: none;
    }
}
</style>